/* Paralela Motion — núcleo (redesign Odd Ritual)
   Fonte dos valores: doc de engenharia reversa §3 (eases) e §5.2 (Lenis).
   Regra da casa: prefers-reduced-motion desliga Lenis e tweens decorativos. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Namespace global para os módulos das etapas seguintes
  window.PRLL = window.PRLL || {};
  window.PRLL.reduce = reduce;
  window.PRLL.lenis = null;
  window.PRLL.isDesktopPointer = function () {
    return window.matchMedia('(min-width: 992px) and (pointer: fine)').matches;
  };

  if (!window.gsap) return;

  gsap.registerPlugin(ScrollTrigger, Observer, CustomEase);

  // Easings assinatura (§3)
  CustomEase.create('ease-1', 'M0,0 C0.15,0 0.15,1 1,1');
  CustomEase.create('ease-2', 'M0,0 C0.071,0.505 0.192,0.726 0.318,0.852 0.45,0.984 0.504,1 1,1');
  CustomEase.create('ease-3', '0.65, 0.01, 0.05, 0.99');
  gsap.defaults({ ease: 'ease-1', duration: 1 });

  // Smooth scroll (§5.2) — sem reduced-motion E SÓ NO COMPUTADOR.
  //
  // A trava de ponteiro entrou em 17/08: rolagem customizada em celular dá
  // sensação de travamento, porque briga com a rolagem nativa do sistema — e
  // o público de anúncio é quase todo mobile. O helper isDesktopPointer já
  // existia aqui em cima e não era usado para isto.
  //
  // Deixar `window.PRLL.lenis` nulo no celular é seguro: TODOS os pontos que
  // o usam guardam com `if (lenis)` ou caem em window.scrollTo — conferidos um
  // a um (preloader, menu, hero, carrossel, ir/abrir avaliações).
  //
  // lagSmoothing(0) fica aqui dentro de propósito: ele existe para casar com o
  // Lenis; sem Lenis, o padrão do GSAP é o melhor comportamento.
  if (!reduce && window.Lenis && window.PRLL.isDesktopPointer()) {
    var lenis = new Lenis();
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
    window.PRLL.lenis = lenis;
  }

  // Módulos das próximas etapas se registram aqui
  // 20/10/2026: cada módulo roda numa tarefa própria, na mesma ordem. Rodando todos de uma vez,
  // a montagem virava uma tarefa longa de 200 a 450 ms no celular (Lighthouse, "long tasks"),
  // que trava o toque e pesa no TBT. Entre um módulo e outro o navegador respira.
  window.PRLL.modules = [];
  var fila = [];
  function rodarFila() {
    var fn = fila.shift();
    if (!fn) return;
    try { fn(); } catch (e) { console.error('[PRLL] módulo ' + (fn.name || '?') + ' falhou:', e); }
    if (fila.length) setTimeout(rodarFila, 0);
  }
  window.PRLL.register = function (fn) {
    window.PRLL.modules.push(fn);
    fila.push(fn);
    if (fila.length === 1) setTimeout(rodarFila, 0);
  };

  // Parallax universal de imagem [img-scroll] (§5.10):
  // container overflow:clip, img 120% de altura, yPercent 0→20 com scrub
  window.PRLL.register(function imgScroll() {
    if (reduce) return;
    document.querySelectorAll('[img-scroll]').forEach(function (wrap) {
      if (wrap.dataset.prllImgScroll) return;
      wrap.dataset.prllImgScroll = '1';
      var img = wrap.querySelector('img, video');
      if (!img) return;
      gsap.fromTo(
        img,
        { yPercent: 0 },
        {
          yPercent: 20,
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'clamp(top bottom)',
            end: 'clamp(bottom top)',
            scrub: true,
          },
        }
      );
    });
  });

  // Etiqueta do card segue o mouse no eixo Y (§5.6/§5.7) — quickTo 0.4s power3,
  // clampada à altura do card; bind preguiçoso via delegação (funciona com infinite scroll)
  window.PRLL.register(function cardCtaFollow() {
    if (reduce) return;
    document.addEventListener('mouseover', function (e) {
      if (!window.PRLL.isDesktopPointer()) return;
      var gal = e.target && e.target.closest ? e.target.closest('.card-gallery') : null;
      if (!gal || gal.dataset.prllCta) return;
      var el = gal.querySelector('[prll-cta-el]');
      if (!el) return;
      gal.dataset.prllCta = '1';
      var setY = gsap.quickTo(el, 'y', { duration: 0.4, ease: 'power3' });
      gal.addEventListener('pointermove', function (ev) {
        var r = gal.getBoundingClientRect();
        var h = el.offsetHeight;
        var y = gsap.utils.clamp(0, r.height - h, ev.clientY - r.top - h / 2);
        setY(y);
      });
    });
  });

  // Preloader — MODULO DESLIGADO EM 21/09/2026.
  //
  // Ele animava a saida com timeline do GSAP, e este arquivo inteiro sai logo
  // no comeco quando o GSAP nao existe (`if (!window.gsap) return` la em cima).
  // Resultado: a tela de abertura ficava refem de uma biblioteca vinda de CDN
  // externo, e a primeira pintura do site publicado saia em 7,0 s.
  //
  // A animacao agora vive em CSS, em snippets/paralela-motion.liquid, e o
  // proprio elemento se remove no 'animationend'. Nao devolver nada disso pra
  // ca: o preloader tem de funcionar mesmo que nenhum script de terceiro
  // carregue.
  //
  // O lenis.stop()/start() que travava a rolagem durante a abertura tambem
  // saiu junto, e e' bom que tenha saido — travar rolagem em celular da'
  // sensacao de site quebrado.

  // Evento de cor (§5.9): body inteiro anima para o oliva escuro ao entrar
  // na seção de pilares; reverte ao voltar (onLeaveBack)
  window.PRLL.register(function colorEvent() {
    if (reduce) return;
    var section = document.querySelector('[data-prll-color-event]');
    if (!section || section.dataset.prllColorEventBound) return;
    section.dataset.prllColorEventBound = '1';
    var GREEN = '#4a5340'; // oliva escuro: mantem contraste 7,7:1 com o texto branco
    var bodyBg0 = getComputedStyle(document.body).backgroundColor;
    var fg0 = getComputedStyle(section).color;

    ScrollTrigger.create({
      trigger: section,
      start: 'top 55%',
      end: 'bottom top',
      onEnter: function () {
        document.body.classList.add('theme-green');
        gsap.to(document.body, { backgroundColor: GREEN, duration: 0.2, ease: 'power2.inOut' });
        gsap.to(section, { color: '#ffffff', duration: 0.2, ease: 'power2.inOut' });
      },
      onLeaveBack: function () {
        document.body.classList.remove('theme-green');
        gsap.to(document.body, { backgroundColor: bodyBg0, duration: 0.2, ease: 'power2.inOut' });
        gsap.to(section, { color: fg0, duration: 0.2, ease: 'power2.inOut' });
      },
    });

    // Parallax de sobreposição dos pilares (entrada em camadas)
    gsap.utils.toArray('[data-scroll-overlap-pillar]').forEach(function (el, i) {
      gsap.fromTo(
        el,
        { yPercent: 20 + i * 10 },
        {
          yPercent: 0,
          ease: 'none',
          scrollTrigger: { trigger: section, start: 'top bottom', end: 'top 30%', scrub: true },
        }
      );
    });
  });

  // "play on." gigante saindo de tras do hero (11/08): mesmo padrao do parallax
  // dos pilares logo acima. O texto nasce deslocado pra cima, escondido atras
  // do hero (que leva z-index maior no prll-redesign), e desliza pra baixo
  // conforme a pagina rola. -170% e' folga proposital: com -125% o texto ficaria
  // a poucos pixels de vazar por baixo da foto.
  window.PRLL.register(function playOnReveal() {
    if (reduce) return;
    var box = document.querySelector('.prll-marquee--static');
    if (!box || box.dataset.prllRevealBound) return;
    box.dataset.prllRevealBound = '1';
    var track = box.querySelector('.prll-marquee__track');
    if (!track) return;

    gsap.fromTo(
      track,
      { yPercent: -170 },
      {
        yPercent: 0,
        ease: 'none',
        scrollTrigger: { trigger: box, start: 'top bottom', end: 'top 30%', scrub: true },
      }
    );
  });

  // "Bem-vindo" rodando 9 idiomas, cada um na letra do alfabeto dele (11/08).
  // Escolha do Rafa: japones, chines, hebraico e tailandes escritos no proprio
  // alfabeto, mais portugues, italiano, ingles, frances e espanhol.
  //
  // Duas camadas empilhadas fazem a travessia cruzada: a de fora sai enquanto
  // a de dentro entra, nunca ha buraco. O fator de escala por entrada existe
  // porque as faces tem alturas muito diferentes no mesmo px — a Parisienne e'
  // minuscula onde a Bebas Neue e' enorme; sem ele o titulo pularia de tamanho.
  window.PRLL.register(function boasVindas() {
    if (reduce) return; // sem movimento: fica so o "Bem-vindo" do template
    // 21/10/2026: com foto no hero (is-foto) nao tem "bem-vindo". Sem esta saida o ramo de baixo
    // recriaria as camadas sozinho e o texto voltaria por cima da foto.
    if (document.querySelector('.prll-hslider.is-foto')) return;
    var alvo = document.querySelector('.prll-hslider__slide[data-index="0"] .prll-hslider__title');
    if (!alvo || alvo.dataset.prllBoasVindas) return;
    alvo.dataset.prllBoasVindas = '1';

    // Ordem alternando latino e alfabeto proprio, pra nunca cair duas
    // parecidas em sequencia.
    var LISTA = [
      { t: 'Bem-vindo', f: "'Parisienne', cursive", w: 400, s: 1.30, ls: '0' },
      { t: '\u3088\u3046\u3053\u305d', f: "'Yuji Syuku', serif", w: 400, s: 0.95, ls: '0.02em' },
      { t: 'Benvenuto', f: "'Courier Prime', monospace", w: 400, s: 0.92, ls: '0' },
      { t: '\u6b22\u8fce', f: "'Ma Shan Zheng', cursive", w: 400, s: 1.15, ls: '0.04em' },
      { t: 'Bienvenue', f: "'Josefin Slab', serif", w: 300, s: 1.10, ls: '0.01em' },
      { t: '\u05d1\u05e8\u05d5\u05da \u05d4\u05d1\u05d0', f: "'Frank Ruhl Libre', serif", w: 300, s: 1.05, ls: '0' },
      { t: 'Welcome', f: "'Oswald', sans-serif", w: 200, s: 1.15, ls: '0.04em' },
      { t: '\u0e22\u0e34\u0e19\u0e14\u0e35\u0e15\u0e49\u0e2d\u0e19\u0e23\u0e31\u0e1a', f: "'Noto Serif Thai', serif", w: 300, s: 0.85, ls: '0' },
      { t: 'Bienvenido', f: "'Playfair Display', serif", w: 400, s: 1.08, ls: '0', it: 1 }
    ];

    // Escala da tipografia do hero. 0.8 = 20% menor que o desenho original.
    var ESCALA = 0.8;

    // A volta inteira dura isto, nao importa quantos idiomas a LISTA tenha.
    // Assim da' pra ACRESCENTAR idioma sem recalcular nada: o intervalo se
    // ajusta sozinho. O Rafa quer mais idiomas, nao menos.
    var VOLTA_MS = 7000;

    // 20/10/2026: as duas camadas ja' vem prontas do Liquid (sections/paralela-hero-slider.liquid),
    // com "Bem-vindo" pintado na letra final. Reaproveitar e NAO repintar a primeira: recriar o
    // texto aqui, depois do GSAP, era o que jogava o LCP pra 8 s. Sem elas, monta como antes.
    var prontas = alvo.querySelectorAll('.prll-bv');
    var camadas;
    if (prontas.length === 2) {
      camadas = [prontas[0], prontas[1]];
    } else {
      alvo.classList.add('prll-bv-host');
      alvo.textContent = '';
      camadas = [document.createElement('span'), document.createElement('span')];
      camadas.forEach(function (el) {
        el.className = 'prll-bv';
        el.setAttribute('dir', 'auto'); // deixa o hebraico correr da direita pra esquerda
        alvo.appendChild(el);
      });
    }

    function pintar(el, item) {
      el.textContent = item.t;
      el.style.fontFamily = item.f;
      el.style.fontStyle = item.it ? 'italic' : 'normal';
      el.style.fontWeight = item.w; // explicito: sem isso o navegador engrossa na marra
      el.style.letterSpacing = item.ls;
      // 21/09/2026 — ESCALA reduz tudo 20% de uma vez (pedido do Rafa). As
      // proporcoes entre os idiomas ficam intactas: cada um continua com o seu
      // `item.s`, so' a base encolheu. Mexer aqui e nao nos `s` da LISTA.
      // ⚠️ A altura do .prll-bv-host, em snippets/prll-redesign.liquid, foi
      // encolhida no mesmo fator — se mudar um, mudar o outro, senao a palavra
      // sobra ou danca dentro da caixa.
      el.style.fontSize = 'clamp(' + (2.2 * ESCALA * item.s).toFixed(2) + 'rem, ' +
        (6 * ESCALA * item.s).toFixed(2) + 'vw, ' + (4.375 * ESCALA * item.s).toFixed(2) + 'rem)';
    }

    var i = 0;
    var atual = 0;

    // 21/09/2026 — A ROTAÇÃO DÁ UMA VOLTA E PARA, descansando no português.
    //
    // Por quê: este span é o maior bloco de texto da primeira tela. Cada palavra
    // nova e maior que a anterior é, para o Chrome, um novo candidato a LCP — a
    // marca reiniciava a cada 2 s e o LCP crescia com o tempo que o medidor
    // ficasse olhando. Não tinha valor fixo: entre medições o elemento marcado
    // mudou de "Bienvenue" para "Welcome".
    //
    // Com a volta fechada, o efeito inteiro aparece (9 idiomas, 18 s) e depois
    // o hero sossega. Decisão do Rafa em 21/09.
    //
    // ⚠️ DUAS TENTATIVAS FALHARAM ANTES DESTA — não repetir:
    //   1. Esperar a fonte aqui no JS (document.fonts.load + teto de 1,2 s):
    //      LCP 8,4 s → 15,0 s. Atrasar a primeira pintura só empurra a
    //      sequência inteira, e a marca do LCP vai junto.
    //   2. Devolver a folha da Parisienne ao estado bloqueante: LCP 8,4 → 8,7 s,
    //      ou seja, nada. O <link> bloqueia o CSS, mas o woff2 continua chegando
    //      depois e o display=swap manda pintar no fallback assim mesmo.
    if (prontas.length !== 2) pintar(camadas[0], LISTA[0]);
    camadas[0].classList.add('is-on');

    // `i` volta a 0 quando a lista fecha o ciclo (o girar usa aritmética
    // modular). É esse retorno que encerra a volta, e ele deixa o hero
    // descansando exatamente na primeira palavra: "Bem-vindo".
    // 7 s divididos pelo numero de trocas ate' fechar a volta.
    var intervalo = Math.round(VOLTA_MS / LISTA.length);

    // A travessia (fade de uma palavra pra outra) tem de caber DENTRO do
    // intervalo, senao as duas camadas se atropelam: a nova acende antes de a
    // anterior apagar e o hero mostra duas palavras sobrepostas. O CSS declara
    // 1,3 s, que servia pro ciclo de 2 s; com o ciclo curto quem manda e' esta
    // conta. 0,7 deixa a palavra parada por um terco do tempo.
    camadas.forEach(function (el) {
      el.style.transitionDuration = Math.round(intervalo * 0.7) + 'ms';
    });

    var timer = setInterval(function () {
      girar();
      if (i === 0) {
        clearInterval(timer);
        // A volta fechou. Avisa quem quiser saber — hoje, o convite para descer
        // (marca + seta) em snippets/paralela-motion.liquid, que estava
        // escondido esperando este momento.
        // ⚠️ Ele NAO depende so' deste aviso: tem uma rede de seguranca de
        // 7200 ms do lado de la', porque este arquivo inteiro desiste na linha
        // 17 quando o GSAP nao existe e entao o evento nunca sairia.
        // ⚠️ VOLTA_MS (7000, acima) e aquele 7200 ANDAM JUNTOS.
        document.dispatchEvent(new CustomEvent('prll:bemvindo-fim'));
      }
    }, intervalo);

    function girar() {
      // Sem deslocamento vertical, a camada que sai ja terminou de apagar
      // (1,3s de travessia dentro de 2s de ciclo) quando chega a vez dela ser
      // repintada. Por isso nao precisa mais desligar transicao nem forcar
      // reflow, como a versao com subida precisava.
      var prox = 1 - atual;
      i = (i + 1) % LISTA.length;
      pintar(camadas[prox], LISTA[i]);
      camadas[prox].classList.add('is-on');
      camadas[atual].classList.remove('is-on');
      atual = prox;
    }
  });

  // Menu overlay fullscreen (§5.5): painéis descem stagger 0.1 (0.575s expo),
  // links stagger 0.05, fades sine.out; fechar inverso expo.out; Esc fecha.
  window.PRLL.register(function menuOverlay() {
    var menu = document.getElementById('prll-menu');
    var toggle = document.querySelector('[prll-menu-open]');
    if (!menu || !toggle || menu.dataset.prllBound) return;
    menu.dataset.prllBound = '1';

    // DESKTOP: o botao entra nas acoes do header, pra alinhar na linha.
    // CELULAR: fica ONDE NASCEU (filho direto do body) e o CSS o fixa no
    // rodape. Enfiar ele dentro do header_section no celular seria a mesma
    // armadilha que quebrou o carrinho em 12/08, so que ao contrario: aquela
    // secao sofre morph a cada mudanca de carrinho, e um elemento que nao
    // existe no HTML novo da secao acaba apagado.
    var actions = document.querySelector('header-component header-actions');
    if (actions && !window.matchMedia('(max-width: 749px)').matches) {
      actions.insertBefore(toggle, actions.firstChild);
    }
    toggle.hidden = false;

    var panels = menu.querySelectorAll('.prll-menu__panel');
    var items = menu.querySelectorAll('.prll-menu__item .prll-menu__link');
    var fades = menu.querySelectorAll('[data-menu-fade]');
    var lenis = window.PRLL.lenis;
    var isOpen = false;
    var busy = false;

    function openMenu() {
      if (isOpen || busy) return;
      isOpen = true;
      if (lenis) lenis.stop();
      document.body.setAttribute('data-nav', 'open');
      toggle.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
      if (reduce) {
        gsap.set(menu, { display: 'block', autoAlpha: 1 });
        gsap.set([panels, items, fades], { clearProps: 'all' });
        return;
      }
      busy = true;
      gsap.set(menu, { display: 'block' });
      gsap
        .timeline({
          defaults: { duration: 0.575, ease: 'expo' },
          onComplete: function () {
            busy = false;
            var first = menu.querySelector('.prll-menu__link');
            if (first) first.focus();
          },
        })
        .fromTo(menu, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.25, ease: 'expo' }, 0)
        .fromTo(panels, { yPercent: -101 }, { yPercent: 0, stagger: 0.1 }, 0.05)
        .fromTo(items, { yPercent: -140 }, { yPercent: 0, stagger: 0.05 }, '<15%')
        .fromTo(fades, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.4, ease: 'sine.out' }, '<70%');
    }

    function closeMenu() {
      if (!isOpen || busy) return;
      isOpen = false;
      toggle.setAttribute('aria-expanded', 'false');
      function done() {
        gsap.set(menu, { display: 'none' });
        menu.setAttribute('aria-hidden', 'true');
        document.body.removeAttribute('data-nav');
        if (lenis) lenis.start();
        toggle.focus();
      }
      if (reduce) {
        gsap.set(menu, { autoAlpha: 0 });
        done();
        return;
      }
      busy = true;
      gsap
        .timeline({
          defaults: { duration: 0.45, ease: 'expo.out' },
          onComplete: function () {
            busy = false;
            done();
          },
        })
        .to(items, { yPercent: -140, stagger: { each: 0.03, from: 'end' } }, 0)
        .to(fades, { autoAlpha: 0, duration: 0.25 }, 0)
        .to(panels, { yPercent: -101, stagger: 0.12 }, 0.1)
        .to(menu, { autoAlpha: 0, duration: 0.25 }, '>-0.15');
    }

    toggle.addEventListener('click', function () {
      isOpen ? closeMenu() : openMenu();
    });
    menu.querySelectorAll('[prll-menu-close]').forEach(function (b) {
      b.addEventListener('click', closeMenu);
    });
    menu.querySelectorAll('.prll-menu__link').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  });

  // Nav some ao chegar no footer (§4): translateY(-100%) via classe .pull-up
  window.PRLL.register(function navPullUp() {
    if (reduce) return;
    var header = document.querySelector('header-component');
    var footer = document.querySelector('body > footer');
    if (!header || !footer || header.dataset.prllPullUp) return;
    header.dataset.prllPullUp = '1';
    ScrollTrigger.create({
      trigger: footer,
      start: 'clamp(top 20%)',
      toggleClass: { targets: header, className: 'pull-up' },
    });
  });

  // Hero slider de cortina (§5.4): slide novo revela por clip-path top→down
  // (1s ease-2), antigo colapsa; parallax interno ±10 yPercent; swipe via Observer
  window.PRLL.register(function heroSlider() {
    var root = document.querySelector('[prll-hero-slider]');
    if (!root || root.dataset.prllBound) return;
    root.dataset.prllBound = '1';
    var slides = gsap.utils.toArray(root.querySelectorAll('.prll-hslider__slide'));
    var dots = gsap.utils.toArray(root.querySelectorAll('.prll-hslider__dot'));
    if (slides.length < 2) return;
    var current = 0;
    var busy = false;
    var CLIP_FULL = 'polygon(0 0, 100% 0, 100% 100%, 0 100%)';
    var CLIP_TOP = 'polygon(0 0, 100% 0, 100% 0, 0 0)';
    var CLIP_BOTTOM = 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)';

    function setDots(i) {
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', i === j);
      });
    }

    function goTo(next, dir) {
      next = ((next % slides.length) + slides.length) % slides.length;
      if (busy || next === current) return;
      var oldSlide = slides[current];
      var newSlide = slides[next];
      var oldImg = oldSlide.querySelector('.prll-hslider__img');
      var newImg = newSlide.querySelector('.prll-hslider__img');
      setDots(next);
      if (reduce) {
        oldSlide.classList.remove('is-active');
        newSlide.classList.add('is-active');
        current = next;
        return;
      }
      busy = true;
      gsap.set(newSlide, {
        visibility: 'visible',
        zIndex: 3,
        clipPath: dir > 0 ? CLIP_TOP : CLIP_BOTTOM,
      });
      gsap
        .timeline({
          defaults: { duration: 1, ease: 'ease-2' },
          onComplete: function () {
            oldSlide.classList.remove('is-active');
            newSlide.classList.add('is-active');
            gsap.set(oldSlide, { clearProps: 'clipPath,zIndex,visibility' });
            gsap.set(newSlide, { clearProps: 'clipPath,zIndex' });
            gsap.set([oldImg, newImg], { clearProps: 'transform' });
            current = next;
            busy = false;
          },
        })
        .to(newSlide, { clipPath: CLIP_FULL }, 0)
        .fromTo(newImg, { yPercent: dir > 0 ? -10 : 10 }, { yPercent: 0 }, 0)
        .to(oldImg, { yPercent: dir > 0 ? 10 : -10 }, 0);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.dataset.goto, 10);
        goTo(i, i > current ? 1 : -1);
      });
    });
    var nextBtn = root.querySelector('[data-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1, 1);
      });
    }
    Observer.create({
      target: root,
      type: 'touch,pointer',
      dragMinimum: 40,
      onLeft: function () {
        goTo(current + 1, 1);
      },
      onRight: function () {
        goTo(current - 1, -1);
      },
    });
  });

  // MODO CAPA — só no celular (17/08/2026, pedido do Rafa).
  // Uma peça grande e nítida no centro, as vizinhas recuadas nos lados, girando
  // em looping e PARANDO em cada uma. O CSS mora em sections/paralela-carousel,
  // todo escopado em `.is-capa`, que é a classe posta aqui embaixo.
  function modoCapa(root, viewport, track) {
    viewport.classList.add('is-capa');

    // Só os originais giram. Os clones (segunda passada do Liquid) existem pro
    // deslize contínuo do DESKTOP e aqui estão escondidos por CSS — o looping
    // do modo capa é aritmética modular, não precisa de cópia.
    var cards = [].slice.call(track.children).filter(function (el) {
      return !el.classList.contains('is-clone');
    });
    var N = cards.length;
    if (N < 2) return;

    var atual = 0;
    var timer = null;
    var espera = (parseFloat(root.dataset.intervalo) || 4) * 1000;

    // ⚠️ ESTE CÓDIGO NÃO CENTRALIZA NADA — quem centraliza é o CSS.
    //
    // Os cards caem todos na mesma célula de grid, com `justify-items: center`
    // (ver sections/paralela-carousel.liquid). O navegador põe cada um no
    // centro; aqui só afastamos os vizinhos. Logo, a peça com `d = 0` recebe
    // `x = 0` e fica exatamente onde o navegador a colocou: no centro.
    //
    // Três tentativas anteriores calculavam a posição aqui e todas erraram —
    // `left:50%` + `margin-left`, depois `xPercent`, depois base medida em
    // pixel. Se voltar a aparecer conta de centralização neste arquivo, é
    // regressão.
    //
    // ⚠️ offsetWidth, NUNCA getBoundingClientRect(): o rect INCLUI as
    // transformações, e os cards laterais estão reduzidos e girados — medir
    // pelo rect faz o passo encolher conforme o carrossel anda.
    function passo() {
      return cards[0].offsetWidth * 0.62;
    }

    function arranjar(anima) {
      var p = passo();
      cards.forEach(function (el, i) { posicionar(el, i, p, anima); });
    }

    function posicionar(el, i, p, anima) {
        // Distância circular MAIS CURTA até o centro. Escrito em duas linhas
        // porque a forma de uma linha só funciona com N par — aqui N é 15.
        var d = (i - atual + N) % N;
        if (d > N / 2) d -= N;
        var ad = Math.abs(d);

        var alvo = {
          // A profundidade é por card: `perspective` no CSS só alcança filho
          // direto, e os cards são netos (viewport > track > card). O track
          // precisa ficar em `transform-style: flat` — se voltar a `preserve-3d`
          // ele vira bloco de referência e a centralização quebra de novo.
          transformPerspective: 1100,
          // d = 0 → x = 0 → fica onde o CSS já centralizou (no viewport).
          x: d * p,
          z: ad === 0 ? 0 : -120 * ad,
          rotationY: d === 0 ? 0 : (d > 0 ? -22 : 22),
          scale: ad === 0 ? 1 : (ad === 1 ? 0.82 : 0.7),
          autoAlpha: ad === 0 ? 1 : (ad === 1 ? 0.5 : 0),
          zIndex: 10 - ad,
          overwrite: 'auto',
        };

        // Só as peças que a pessoa enxerga ganham tween. Da terceira em
        // diante o autoAlpha ali em cima já é 0 — animar em 3D, com easing,
        // o que está invisível era ~2/3 do custo de CPU do carrossel, e isso
        // se repetia a cada ciclo de 4s pra sempre (medido em 21/09/2026).
        // O limite é `ad <= 2`, não `ad <= 1`: a peça que sai de 1 para 2
        // precisa do tween pra desaparecer suave. Cortar em 1 faz ela sumir
        // de estalo.
        if (anima && ad <= 2) {
          alvo.duration = 0.7;
          alvo.ease = 'expo.out';
          gsap.to(el, alvo);
        } else {
          gsap.set(el, alvo);
        }

        // Só a peça do centro é clicável e existe pro leitor de tela; sem isso
        // dá pra tabular em card invisível e o toque pega a peça errada.
        el.style.pointerEvents = ad === 0 ? 'auto' : 'none';
        el.tabIndex = ad === 0 ? 0 : -1;
        if (ad === 0) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', 'true');
    }

    function ir(n) {
      atual = ((atual + n) % N + N) % N;
      arranjar(true);
    }

    function tocar() {
      parar();
      timer = setInterval(function () { ir(1); }, espera);
    }
    function parar() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // O posicionamento inicial continua no carregamento — são 15 `gsap.set`,
    // sem tween, e sem isso os cards ficam empilhados no centro (todos caem na
    // mesma célula de grid; quem os afasta é este arranjar).
    // 20/10/2026: o arranjo inicial vai UM CARD POR TAREFA, do centro pra fora. Feito de uma vez
    // ele virava a maior tarefa da home no celular (~450 ms com CPU 4x): cada gsap.set lê o estilo
    // atual antes de escrever, e cada escrita obriga o navegador a recalcular a página (50-80 ms por
    // card, medido). O carrossel fica abaixo do hero de tela cheia, então ninguém vê a montagem.
    // Clique, arrasto e autoplay chamam arranjar() inteiro e continuam valendo no meio da fila:
    // posicionar() calcula a distância com o `atual` da hora.
    (function arranjarAosPoucos() {
      var p = passo();
      var ordem = cards.map(function (el, i) {
        var d = (i - atual + N) % N;
        if (d > N / 2) d -= N;
        return [Math.abs(d), i];
      }).sort(function (a, b) { return a[0] - b[0]; });
      (function proximo() {
        var item = ordem.shift();
        if (!item) return;
        posicionar(cards[item[1]], item[1], p, false);
        if (ordem.length) setTimeout(proximo, 0);
      })();
    })();

    // O AUTOPLAY, esse sim, só roda com o carrossel na tela. Antes começava
    // junto com o carregamento e disputava CPU com a primeira pintura — o LCP
    // media 14,6 s no celular em 21/09/2026 — e seguia girando com a pessoa
    // lendo o rodapé.
    var naTela = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        naTela = entradas[0].isIntersecting;
        if (naTela && !document.hidden) tocar();
        else parar();
      }, { threshold: 0.2 }).observe(viewport);
    } else {
      naTela = true;
      tocar();
    }

    // Aba em segundo plano: parar. Sem isto o setInterval acumula avanços e o
    // carrossel volta "adiantado" quando a pessoa retorna.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar();
      else if (naTela) tocar();
    });

    window.addEventListener('resize', function () { arranjar(false); });

    root.querySelectorAll('[data-prll-capa]').forEach(function (b) {
      b.addEventListener('click', function () {
        ir(parseInt(b.dataset.prllCapa, 10));
        tocar();
      });
    });

    // Arrasto.
    //
    // ⚠️ O limiar é fração da LARGURA DO CARD, nunca do passo. Já foi
    // `passo() * 0.45` e isso acoplou duas coisas sem relação: ao corrigir a
    // medida do passo (rect → offsetWidth, que devolve valor maior), o limiar
    // subiu junto e o arrasto ficou pesado — o dedo tinha que percorrer muito
    // pro carrossel reagir. Quem manda aqui é o que o dedo percebe.
    //
    // Sem `lockAxis` e sem guarda de eixo: quem impede o arrasto lateral de
    // sequestrar a rolagem vertical é o `touch-action: pan-y` do CSS, aplicado
    // pelo navegador antes de qualquer JS. A guarda era proteção repetida e
    // engolia o gesto.
    var acumulado = 0;
    var arrastou = false;

    // ⚠️ Escuta no VIEWPORT, não no track: com os cards em position:absolute o
    // track fica sem altura e não recebe gesto nenhum. O viewport tem o
    // min-height do palco.
    Observer.create({
      target: viewport,
      type: 'touch,pointer',
      dragMinimum: 6,
      onPress: function () {
        parar();
        acumulado = 0;
        arrastou = false;
        track.classList.add('is-dragging');
      },
      onDrag: function (self) {
        acumulado += self.deltaX;
        if (Math.abs(acumulado) > cards[0].offsetWidth * 0.22) {
          arrastou = true;
          ir(acumulado > 0 ? -1 : 1);
          acumulado = 0;
        }
      },
      onRelease: function () {
        track.classList.remove('is-dragging');
        tocar();
      },
    });

    // A peça central é um <a>: sem isto, arrastar em cima dela e soltar abre o
    // produto. Captura na fase de captura pra chegar antes do link.
    viewport.addEventListener(
      'click',
      function (e) {
        if (!arrastou) return;
        e.preventDefault();
        e.stopPropagation();
        arrastou = false;
      },
      true
    );
  }

  // Carrossel de produtos infinito (§5.8): auto-scroll contínuo + arrastável, wrap infinito.
  // reduced-motion → scroll horizontal nativo com snap; celular → modo capa.
  window.PRLL.register(function productCarousel() {
    document.querySelectorAll('[data-prll-carousel]').forEach(function (root) {
      if (root.dataset.prllCarBound) return;
      root.dataset.prllCarBound = '1';
      var viewport = root.querySelector('.prll-carousel__viewport');
      var track = root.querySelector('[data-prll-carousel-track]');
      if (!viewport || !track || track.children.length < 2) return;

      // Movimento reduzido: rolagem horizontal simples, sem 3D e sem autoplay.
      if (reduce) {
        viewport.classList.add('is-native');
        return;
      }

      // CELULAR: modo capa (17/08/2026). Uma peça grande e nítida no centro,
      // as vizinhas recuadas, girando em looping e PARANDO em cada uma.
      // O desktop segue no deslize contínuo, logo abaixo, sem alteração.
      if (!window.PRLL.isDesktopPointer()) {
        modoCapa(root, viewport, track);
        return;
      }

      var half = track.scrollWidth / 2;
      window.addEventListener('resize', function () { half = track.scrollWidth / 2; });

      var x = 0;
      var base = (parseFloat(root.dataset.speed) || 1) * 40; // px/s — auto-scroll padrão (um pouco mais rápido)
      var maxHover = base * 6;   // velocidade máxima (só nos cantos extremos)
      var vel = -base;           // velocidade atual (px/s); negativo = revela à direita
      var pos = 0;               // -1 (canto esq.) .. 0 (meio) .. +1 (canto dir.)
      var hovering = false;
      var dragging = false;

      // Mouse controla velocidade e direção: meio = devagar, cantos = rápido,
      // e o carrossel "vai para o lado" onde o mouse está.
      viewport.addEventListener('mousemove', function (e) {
        var r = viewport.getBoundingClientRect();
        pos = gsap.utils.clamp(-1, 1, ((e.clientX - r.left) / r.width) * 2 - 1);
        hovering = true;
      });
      viewport.addEventListener('mouseleave', function () { hovering = false; });

      gsap.ticker.add(function (time, dt) {
        if (!dragging) {
          var targetVel = -base;
          if (hovering) {
            // curva: miolo suave, dispara só nos cantos extremos (direção original)
            var curve = Math.sign(pos) * Math.pow(Math.abs(pos), 3);
            targetVel = -curve * maxHover;
          }
          var k = Math.min(1, (dt / 1000) * 5); // suaviza a mudança de velocidade (~0.2s)
          vel += (targetVel - vel) * k;
          x += (dt / 1000) * vel;
        }
        gsap.set(track, { x: gsap.utils.wrap(-half, 0, x) });
      });

      var lenis = window.PRLL.lenis;
      Observer.create({
        target: track,
        type: 'pointer,touch',
        dragMinimum: 4,
        onPress: function () {
          dragging = true;
          track.classList.add('is-dragging');
          gsap.to(track.children, { scale: 0.97, duration: 0.3, ease: 'power1' });
          if (lenis) lenis.stop();
        },
        onDrag: function (self) {
          x += self.deltaX;
          gsap.set(track, { x: gsap.utils.wrap(-half, 0, x) });
        },
        onRelease: function () {
          dragging = false;
          track.classList.remove('is-dragging');
          gsap.to(track.children, { scale: 1, duration: 0.3, ease: 'power1' });
          if (lenis) lenis.start();
        },
      });
    });
  });

  // Reveal suave no scroll: [data-prll-reveal] (bloco) e [data-prll-reveal-stagger] (filhos)
  window.PRLL.register(function revealOnScroll() {
    if (reduce) return; // conteúdo permanece visível
    var items = [].slice.call(
      document.querySelectorAll('[data-prll-reveal], [data-prll-reveal-stagger]')
    );
    items.forEach(function (el) {
      if (el.dataset.prllRevealBound) return;
      el.dataset.prllRevealBound = '1';
      var stagger = el.hasAttribute('data-prll-reveal-stagger');
      var targets = stagger ? el.children : [el];
      if (!targets.length) return;
      gsap.set(targets, { autoAlpha: 0, y: 24, scale: 0.985 });
      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.to(targets, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            ease: 'ease-1',
            stagger: stagger ? 0.07 : 0,
          });
        },
      });
    });
  });

  // Botões magnéticos (vibe Odd Ritual §5.6): CTAs seguem o cursor de leve e voltam
  // no pointerleave. Só desktop com ponteiro fino; desligado em reduced-motion.
  window.PRLL.register(function magneticButtons() {
    if (reduce || !window.PRLL.isDesktopPointer()) return;
    var sel = '.prll-community__button, .prll-hslider__cta, .prll-carousel__viewall, .prll-showcase__viewall';
    document.querySelectorAll(sel).forEach(function (btn) {
      if (btn.dataset.prllMagnet) return;
      btn.dataset.prllMagnet = '1';
      var xTo = gsap.quickTo(btn, 'x', { duration: 0.5, ease: 'power3' });
      var yTo = gsap.quickTo(btn, 'y', { duration: 0.5, ease: 'power3' });
      var max = 9;
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        xTo(gsap.utils.clamp(-max, max, (e.clientX - (r.left + r.width / 2)) * 0.35));
        yTo(gsap.utils.clamp(-max, max, (e.clientY - (r.top + r.height / 2)) * 0.35));
      });
      btn.addEventListener('pointerleave', function () { xTo(0); yTo(0); });
    });
  });

  // heroScrollCue — MODULO DESLIGADO EM 22/09/2026.
  //
  // Ele animava e dava clique ao <span class="prll-hslider__scroll">Scroll</span>,
  // que SAIU da section nesta mesma data. O papel dele — dizer que existe loja
  // abaixo da primeira tela — passou para .prll-hslider__cue (a marca P com a
  // seta), e tanto o clique quanto a respiracao moraram para
  // snippets/paralela-motion.liquid e para o CSS da section.
  //
  // ⚠️ NAO reescrever isto aqui apontando para a cue nova. Duas razoes:
  //   1. este arquivo inteiro desiste na linha 17 quando o GSAP nao existe
  //      (`if (!window.gsap) return`). O clique para descer a pagina ficaria
  //      refem de uma biblioteca de CDN — o mesmo defeito que tirou o preloader
  //      daqui em 21/09;
  //   2. a cue ja' tem listener de clique do outro lado. Religar este modulo
  //      registraria o segundo, e um clique rolaria a pagina duas vezes.
  //
  // O <button> novo tambem dispensa o role/tabindex que este modulo precisava
  // aplicar na mao, e a respiracao virou @keyframes em CSS.

  // "Ler avaliações" (estrelas do topo → lista do Judge.me lá embaixo).
  // O link nasce em blocks/review.liquid; aqui só mora a rolagem.
  //
  // ⚠️ Listener DELEGADO no document, de propósito. A seção do produto sofre
  // morph() a cada troca de variante (assets/section-renderer.js): um listener
  // preso ao botão morreria na primeira troca de tamanho. Delegado, o botão
  // pode ser redesenhado à vontade. É primo do bug que quebrou o carrinho
  // em 12/08 — lá o erro foi mover elemento, aqui seria prender evento nele.
  window.PRLL.register(function irParaAvaliacoes() {
    if (document.body.dataset.prllAvalBound) return;
    document.body.dataset.prllAvalBound = '1';

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[prll-ir-avaliacoes]');
      if (!btn) return;
      var alvo = document.getElementById('judgeme_product_reviews');
      if (!alvo) return; // widget ausente: deixa o link seguir como âncora normal
      e.preventDefault();
      // Desconta o cabeçalho flutuante pra o título das avaliações não nascer colado no topo.
      var y = alvo.getBoundingClientRect().top + window.scrollY - 80;
      if (window.PRLL.lenis) window.PRLL.lenis.scrollTo(y, { duration: 1.1 });
      else window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  // Link de pedir avaliação: /products/<peça>?avaliar=1
  // Cai na página, desce até as avaliações e ABRE o formulário sozinho.
  //
  // Por que caseiro em vez do link do Judge.me: eles não expõem formulário
  // público por URL (testado em 13/08 — /review/new, /reviews/new e
  // api.judge.me devolvem 404). Os e-mails deles usam token assinado, que não
  // dá pra montar aqui. Este parâmetro é nosso e não depende do app.
  //
  // O widget monta por JS depois da página, então não adianta procurar o botão
  // na carga: espera ele aparecer, com teto de 10s pra nunca ficar rodando.
  // Em tema sem este código o parâmetro é simplesmente ignorado — o cliente cai
  // na página do produto normalmente. Por isso o link pode ser enviado antes
  // mesmo de publicar.
  //
  // 🔴 ESTE LINK FICOU QUEBRADO ATÉ 31/08/2026. Ele procurava
  // `.jdgm-write-rev-link`, do widget LEGADO, e o Judge.me migrou pro widget
  // "revamp" (app Vue, namespace `jm-`). O seletor não casava com nada: o
  // cliente clicava no pedido de avaliação, caía na página e o formulário
  // nunca abria — depois de 10s o timer desistia calado. É o link que sai no
  // material de 10_WEBSITE/PEDIR-AVALIACOES.md.
  // O seletor abaixo cobre os dois widgets: o novo primeiro, o legado como
  // reserva caso o app volte atrás.
  window.PRLL.register(function abrirFormAvaliacao() {
    if (!/[?&]avaliar=1(&|$)/.test(window.location.search)) return;
    if (document.body.dataset.prllAvaliarBound) return;
    document.body.dataset.prllAvaliarBound = '1';

    var tentativas = 0;
    var timer = setInterval(function () {
      var botao = document.querySelector(
        '#judgeme_product_reviews .jm-action-buttons__button, .jdgm-write-rev-link'
      );
      if (botao) {
        clearInterval(timer);
        var alvo = document.getElementById('judgeme_product_reviews');
        if (alvo) {
          var y = alvo.getBoundingClientRect().top + window.scrollY - 80;
          if (window.PRLL.lenis) window.PRLL.lenis.scrollTo(y, { duration: 1.1 });
          else window.scrollTo({ top: y, behavior: 'smooth' });
        }
        // Só clica depois que a rolagem assentou, senão o formulário abre com
        // a página ainda em movimento e o cliente perde a referência.
        setTimeout(function () { botao.click(); }, 1200);
        return;
      }
      if (++tentativas > 50) clearInterval(timer); // 50 x 200ms = 10s
    }, 200);
  });

  // ⚠️ AQUI VIVIA `abrirAvaliacaoPeloBotao`, removido em 31/08/2026.
  // Ele servia a um botão nosso, `[prll-abrir-avaliacao]`, que existia em
  // snippets/prll-avalie-ganhe.liquid pra substituir o do Judge.me — que eu
  // acreditava escondido por CSS e não estava: o app tinha migrado pro widget
  // "revamp" (Vue, namespace `jm-`) e o seletor `jdgm-` não casava com nada.
  // Resultado: dois botões na tela. Agora o botão é o do próprio app,
  // reordenado por CSS em snippets/prll-redesign.liquid, e não há clique
  // sintético nenhum no caminho.

  // Re-inicialização quando o editor de temas recarrega seções
  document.addEventListener('shopify:section:load', function () {
    window.PRLL.modules.forEach(function (fn) { fn(); });
    ScrollTrigger.refresh();
  });
})();
